document.addEventListener('DOMContentLoaded', function() {
  let tooltips = Array.from(document.getElementsByClassName("tenf-tooltip"));

  tooltips.forEach((tooltip) => {
    tooltip.addEventListener("click", (e) => {
      if (tooltip.dataset.open == "false") {
        tooltip.dataset.open = "true";
      } else {
        tooltip.dataset.open = "false";
      }
    });
  });

}, false);
